import { NavLink } from "react-router-dom";
import { IssueData } from "./IssuePage";
import Image from "../../Image/Image";
import { IsoToDateWithTime } from "../../../../CommonFunction/IsoDateTime";
type ExtendedIssueData = IssueData & { Title: string } & { modal: boolean };
export const IssueCard = ({
  Unique_Id,
  createdAt,
  UserName,
  Name,
  Issue_Related_To,
  Issue_Subject,
  Issue_Details,
  Doc_1,
  Doc_2,
  Doc_3,
  Doc_4,
  _id,
  Title,
  modal,
}: ExtendedIssueData) => {
  return (
    <>
      <div className="IssueCart">
        <div>
          {!modal ? (
            <NavLink className="Links" to={`/RequestSupport/ticket/${_id}?status=${Title.replace(/\s+/g, "")}`}>
              <p>{Unique_Id}</p>
              <span>{IsoToDateWithTime(createdAt)}</span>
              <span>by {UserName}</span>
            </NavLink>
          ) : (
            <>
              <p>{Unique_Id}</p>
              <span>{IsoToDateWithTime(createdAt)}</span>
              <span>by {UserName}</span>
            </>
          )}
        </div>
        <div>
          {!modal ? (
            <NavLink className="Links" to={`/RequestSupport/ticket/${_id}?status=${Title.replace(/\s+/g, "")}`}>
              <span>{Issue_Related_To}</span>
              <h4>{Issue_Subject}</h4>
              <p>{Issue_Details}</p>
            </NavLink>
          ) : (
            <>
              <span>{Issue_Related_To}</span>
              <h4>{Issue_Subject}</h4>
              <p>{Issue_Details}</p>
            </>
          )}
          <div className="imageContainer">
            {Doc_1 && <Image img={Doc_1} name="Doc 1" toggle={true} width={50} height={50} IssueImg={true} />}
            {Doc_2 && <Image img={Doc_2} name="Doc 2" toggle={true} width={50} height={50} IssueImg={true} />}
            {Doc_3 && <Image img={Doc_3} name="Doc 3" toggle={true} width={50} height={50} IssueImg={true} />}
            {Doc_4 && <Image img={Doc_4} name="Doc 4" toggle={true} width={50} height={50} IssueImg={true} />}
          </div>
        </div>
      </div>
    </>
  );
};
